import { MentionInsightApiModel } from '../../../api/mentions/model/mention-insight-api.model';

export class MentionInsightModel {
    id: string;
    content: string;
    name: string;
    isPreferred: boolean;
    oldName?: string;
    oldContent?: string;

    constructor(apiModel?: MentionInsightApiModel) {
        if (apiModel) {
            this.content = apiModel.content;
            this.name = apiModel.name;
            this.isPreferred = apiModel.isPreferred;
            this.oldName = this.name;
            this.oldContent = this.content;
        }

        this.id = Date.now().toString(36) + Math.random().toString(36).substring(2);
    }

    toApiModel(): MentionInsightApiModel {
        return {
            name: this.name,
            content: this.content,
            isPreferred: this.isPreferred,
        } as MentionInsightApiModel;
    };
}
